import { z } from "zod";

type RGB = { red: number; green: number; blue: number };
const rgbZodSchema = z.object({
    red: z.number().min(0).max(255),
    green: z.number().min(0).max(255),
    blue: z.number().min(0).max(255),
});

export type { RGB };
export { rgbZodSchema };
